<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6 lg5 xl4>
            <v-card class="elevation-1">
              <v-toolbar dark color="light-blue darken-3" class="elevation-0">
                <v-toolbar-title>Авторизация</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-title>[edoc].cloud</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-text-field
                    v-model="phone" 
                    :rules="phoneRules"
                    :error-messages="errors.phone"
                    placeholder="Пример 38 (093) 777-55-44"
                    required
                    prepend-icon="phone" 
                    mask="## (###) ###-##-##" 
                    label="Номер телефона" 
                    type="text"></v-text-field>
                  <v-text-field
                    v-model="password" 
                    :rules="passwordRules"
                    placeholder="Пароль 6 символов"
                    required
                    prepend-icon="lock"
                    type="password"
                    label="Пароль"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="light-blue darken-3" dark @click="submit()">Войти</v-btn>
              </v-card-actions>
            </v-card>
            <v-card class="elevation-1 mt-3">
              <v-card-text>
                Еще нет аккаунта? <router-link :to="{name:'reg'}">Зарегистрироваться</router-link>
              </v-card-text>
            </v-card>
            <v-card class="elevation-1 mt-3">
              <v-card-text>
                Забыли пароль? <router-link :to="{name:'recover'}">Восстановить</router-link>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    valid: true,
    phone: '',
    password: '',
    errors: {
      phone: []
    },
    phoneRules: [v => !!v || 'Обязательное поле'],
    passwordRules: [
      v => !!v || 'Обязательное поле',
      v => v.length >= 6 || 'Минимальная длина пароля 6 символов'
    ]
  }),
  methods: {
    submit () {

      if (!this.$refs.form.validate()) {
        return
      }

      this.$store
        .dispatch('userLogin', {
          phone: this.phone,
          password: this.password
        })
        .then(response => {
          localStorage.setItem('token', response.data.token)
          this.$router.push({name: 'pending_document_list'})
        })
        .catch((err) => {
          this.errors = err.response.data.errors
        })
    }
  }
}
</script>